// reducer.js
import {
  GET_LEAD_NOTES,
  GET_LEAD_NOTES_SUCCESS,
  GET_LEAD_NOTES_ERROR,
  CREATE_LEAD_NOTES,
  CREATE_LEAD_NOTES_SUCCESS,
  CREATE_LEAD_NOTES_ERROR,
  UPDATE_LEAD_NOTES,
  UPDATE_LEAD_NOTES_SUCCESS,
  UPDATE_LEAD_NOTES_ERROR,
  DELETE_LEAD_NOTES,
  DELETE_LEAD_NOTES_SUCCESS,
  DELETE_LEAD_NOTES_ERROR,
  GET_CALL_NOTES,
  GET_CALL_NOTES_SUCCESS,
  GET_CALL_NOTES_ERROR,
  CREATE_CALL_NOTES,
  CREATE_CALL_NOTES_SUCCESS,
  CREATE_CALL_NOTES_ERROR,
  UPDATE_CALL_NOTES,
  UPDATE_CALL_NOTES_SUCCESS,
  UPDATE_CALL_NOTES_ERROR,
  DELETE_CALL_NOTES,
  DELETE_CALL_NOTES_SUCCESS,
  DELETE_CALL_NOTES_ERROR,
} from "./actionTypes";

const initialState = {
  lead_notes_loading: false,
  lead_notes_error: null,
  lead_notes: [],
  call_notes_loading: false,
  call_notes_error: null,
  call_notes: [],
};

const leadNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD_NOTES:
    case CREATE_LEAD_NOTES:
    case UPDATE_LEAD_NOTES:
    case DELETE_LEAD_NOTES:
      return {
        ...state,
        lead_notes_loading: true,
        lead_notes_error: null,
      };

    case GET_LEAD_NOTES_SUCCESS:
      // Handle both old format (array) and new format (object with notes and processedLeadIds)
      const payload = action.payload;
      let newNotes = [];
      let processedLeadIds = [];

      if (Array.isArray(payload)) {
        // Old format: array of notes
        newNotes = payload;
      } else if (payload && payload.notes && Array.isArray(payload.notes)) {
        // New format: object with { notes: [], processedLeadIds: [] }
        newNotes = payload.notes;
        processedLeadIds = payload.processedLeadIds || [];
      }

      // Smart merging: Replace notes for specific lead_ids to prevent stale cache
      if (processedLeadIds.length > 0) {
        // Remove notes for processed lead_ids and add new ones
        const filteredNotes = state.lead_notes.filter(
          (note) => !processedLeadIds.includes(note.lead_id)
        );
        return {
          ...state,
          lead_notes_loading: false,
          lead_notes: [...filteredNotes, ...newNotes],
        };
      } else {
        // If no processedLeadIds, just merge (for backward compatibility)
        return {
          ...state,
          lead_notes_loading: false,
          lead_notes: newNotes,
        };
      }

    case CREATE_LEAD_NOTES_SUCCESS:
      return {
        ...state,
        lead_notes_loading: false,
        lead_notes: [...state.lead_notes, action.payload],
      };

    case UPDATE_LEAD_NOTES_SUCCESS:
      return {
        ...state,
        lead_notes_loading: false,
        lead_notes: state.lead_notes.map((lead_note) => {
          if (lead_note.id === action.payload.id) {
            return action.payload;
          }
          return lead_note;
        }),
      };

    case DELETE_LEAD_NOTES_SUCCESS:
      return {
        ...state,
        lead_notes_loading: false,
        lead_notes: state.lead_notes.filter(
          (lead_note) => lead_note.id !== action.payload.id
        ),
      };

    case GET_LEAD_NOTES_ERROR:
    case CREATE_LEAD_NOTES_ERROR:
    case UPDATE_LEAD_NOTES_ERROR:
    case DELETE_LEAD_NOTES_ERROR:
      return {
        ...state,
        lead_notes_loading: false,
        lead_notes_error: action.payload,
      };

    case GET_CALL_NOTES:
    case CREATE_CALL_NOTES:
    case UPDATE_CALL_NOTES:
    case DELETE_CALL_NOTES:
      return {
        ...state,
        call_notes_loading: true,
        call_notes_error: null,
      };

    case GET_CALL_NOTES_SUCCESS:
      // Handle both old format (array) and new format (object with notes and processedCallIds)
      const callPayload = action.payload;
      let newCallNotes = [];
      let processedCallIds = [];

      if (Array.isArray(callPayload)) {
        // Old format: array of notes
        newCallNotes = callPayload;
      } else if (callPayload && callPayload.notes && Array.isArray(callPayload.notes)) {
        // New format: object with { notes: [], processedCallIds: [] }
        newCallNotes = callPayload.notes;
        processedCallIds = callPayload.processedCallIds || [];
      }

      // Smart merging: Replace notes for specific call_ids to prevent stale cache
      if (processedCallIds.length > 0) {
        // Remove notes for processed call_ids and add new ones
        const filteredCallNotes = state.call_notes.filter(
          (note) => !processedCallIds.includes(note.quote_call_id)
        );
        return {
          ...state,
          call_notes_loading: false,
          call_notes: [...filteredCallNotes, ...newCallNotes],
        };
      } else {
        // If no processedCallIds, just merge (for backward compatibility)
        return {
          ...state,
          call_notes_loading: false,
          call_notes: newCallNotes,
        };
      }

    case CREATE_CALL_NOTES_SUCCESS:
      return {
        ...state,
        call_notes_loading: false,
        call_notes: [...state.call_notes, action.payload],
      };

    case UPDATE_CALL_NOTES_SUCCESS:
      return {
        ...state,
        call_notes_loading: false,
        call_notes: state.call_notes.map((call_note) => {
          if (call_note.id === action.payload.id) {
            return action.payload;
          }
          return call_note;
        }),
      };

    case DELETE_CALL_NOTES_SUCCESS:
      return {
        ...state,
        call_notes_loading: false,
        call_notes: state.call_notes.filter(
          (call_note) => call_note.id !== action.payload.id
        ),
      };

    case GET_CALL_NOTES_ERROR:
    case CREATE_CALL_NOTES_ERROR:
    case UPDATE_CALL_NOTES_ERROR:
    case DELETE_CALL_NOTES_ERROR:
      return {
        ...state,
        call_notes_loading: false,
        call_notes_error: action.payload,
      };

    default:
      return state;
  }
};

export default leadNotesReducer;
